(function (angular) {
	'use strict';

	angular
		.module('twoFactorAuthModule')
		.controller('TwoFactorSelection', [
			'urlFactory',
			TwoFactorSelectionFunction
		]);

	function TwoFactorSelectionFunction(
		urlFactory
	) {
		var twoFactorSelection = this;

		twoFactorSelection.redirect = function() {
			urlFactory.redirect('/account/security/two-factor-authentication/' + twoFactorSelection.type);
		};

		twoFactorSelection.$onInit = function() {
			twoFactorSelection.type = 'totp';
		};
	}
})(window.angular);